import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.DialogBottomSheet,
        {
          attrs: {
            "is-visible": _setup.isDialogOpened,
            width: _setup.isMobile ? undefined : 375,
            "content-class": "rounded-0",
          },
          on: { input: _setup.handleInput },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-6 px-4 pb-4", attrs: { tile: "" } },
            [
              _c(
                VForm,
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _setup.applyFilter.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(_setup.FieldPrices, {
                    staticClass: "mb-4",
                    attrs: {
                      "is-visible": _setup.isDialogOpened,
                      autofocus: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "text-h6 mb-4" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _setup.t("Стоимость приёма", _setup.options)
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _setup.filtersStore.unsavedFilters,
                      callback: function ($$v) {
                        _vm.$set(_setup.filtersStore, "unsavedFilters", $$v)
                      },
                      expression: "filtersStore.unsavedFilters",
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.BtnShowDoctors, {
                    attrs: { active: _setup.isDialogOpened },
                    on: {
                      "click:close": _setup.closeDialog,
                      "click:submit": _setup.applyFilter,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }